import { createStructuredSelector } from "reselect";
import {
    ORP_PRICE_GRAPH,
    ORP_PRICE_GRAPH_SUCCESS,
    ORP_PRICE_GRAPH_ERROR,
    ORP_PRICE_SEARCH_SET,
    ORP_PRICE_SEARCH_CHANGE
} from "../actions";

export const NAME = 'orp';

export const OrpPriceGraph = (filters, stateFilter) => ({
    type: ORP_PRICE_GRAPH,
    payload: { filters: filters, filtersState: stateFilter }
});

export const OrpPriceGraphSuccess = (data) => ({
    type: ORP_PRICE_GRAPH_SUCCESS,
    payload: data
});

export const OrpPriceGraphError = (error) => ({
    type: ORP_PRICE_GRAPH_ERROR,
    payload: error
});

export const OrpPriceSearchSet = (data) => ({
    type: ORP_PRICE_SEARCH_SET,
    payload: data
});

export const OrpPriceSearchChangeSet = (data) => ({
    type: ORP_PRICE_SEARCH_CHANGE,
    payload: data
});


const orp = (state) => state[NAME];

export const OrpSelector = createStructuredSelector({
    orp
})
